import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { ApiVersions } from './api-version';
import { map } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { EmailTemplate } from '../models/email-templates/emailTemplate';

@Injectable({
  providedIn: 'root',
})
export class EmailTemplateService extends BaseService {
  private readonly basePath = 'email-templates';
  public emailTemplates = new Subject<EmailTemplate[]>();

  constructor() {
    super();
  }

  getAll() {
    this.get<EmailTemplate[]>(this.basePath, null, ApiVersions.v0_1)
      .pipe(
        map((data) =>
          data?.map((app) => {
            return EmailTemplate.parse(app);
          })
        )
      )
      .subscribe((data) => {
        this.emailTemplates.next(data);
      });
  }

  setDefaultTemplate(id: string) {
    this.patch(`${this.basePath}/${id}/default`, null, ApiVersions.v0_1).subscribe(() => {
      return this.getAll();
    });
  }

  deleteTemplate(id: string) {
    this.delete(`${this.basePath}/${id}`, null, ApiVersions.v0_1, true).subscribe(
      () => {
        this.openSnackBar('Successfully deleted email template', true);
        return this.getAll();
      },
      (err) => {
        if (err.status >= 400 && err.status < 500) {
          var message = err.error;
        } else {
          message = 'There was an error deleting the email template';
        }
        this.openSnackBar(message, false);
      }
    );
  }

  addTemplate(emailTemplate: EmailTemplate) {
    let body = JSON.stringify(emailTemplate);
    this.post(`${this.basePath}`, body, null, ApiVersions.v0_1, true).subscribe(
      () => {
        this.openSnackBar('Successfully added new email template', true);
        return this.getAll();
      },
      (err) => {
        if (err?.error) {
          this.openSnackBar(err.error, false);
        } else {
          this.openSnackBar('There was an error when adding email template', false);
        }
      }
    );
  }

  updateTemplate(emailTemplate: EmailTemplate) {
    let body = JSON.stringify(emailTemplate);
    this.put(`${this.basePath}/${emailTemplate.id}`, body, null, ApiVersions.v0_1, true).subscribe(
      () => {
        this.openSnackBar('Successfully saved email template', true);
        return this.getAll();
      },
      (err) => {
        if (err?.error) {
          this.openSnackBar(err.error, false);
        } else {
          this.openSnackBar('There was an error when saving email template', false);
        }
      }
    );
  }
}
